import React, { useState, useContext, useRef } from "react";
import { Col, Row, CardBody, Input, Label, FormGroup, Form } from "reactstrap";
import Select from "react-select";
import SikkaSelect from "../../common/SikkaSelect/SikkaSelect";
import {
  FormLabel,
  Button,
  Tooltip,
  Image,
  OverlayTrigger,
  Card,
} from "react-bootstrap";
import SikkaCardHeader from "../../common/SikkaCardHeader";
import QuillEditor from "../../common/QuillEditor";
import FalconDropzone from "../../common/FalconDropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faUserAstronaut, faWandSparkles} from "@fortawesome/free-solid-svg-icons";
import HeadlineTooltip from "../../../assets/img/tooltips/Headlinetooltipimage.png";
import DescriptionTooltip from "../../../assets/img/tooltips/Descriptiontooltipimage.png";
import Marketplacebackgroundtooltipimage from "../../../assets/img/tooltips/Marketplacebackgroundtooltipimage.png";
import Promotionaltooltipimage from "../../../assets/img/tooltips/Promotionaltooltipimage.png";
import Categorytooltipimage from "../../../assets/img/tooltips/Categorytooltipimage.png";
import cloudUpload from "../../../assets/img/icons/cloud-upload.svg";
import Flex from "../../common/Flex";
import Avatar from "../../common/Avatar";
import { isIterableArray } from "../../../helpers/utils";
import SikkaInput from "../../common/SikkaInput";
import SikkaError from "../../common/SikkaError";
// import { useForm } from "react-hook-form";
import classNames from "classnames";
import AppContext, { PublishAppContext } from "../../../context/Context";
import apiCall from "../../../services/apiCall";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import IconButton from "../../common/IconButton";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Thankyou_MobileIMG from "../../../assets/img/thankyou_mobile.png";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
    [{ color: [] }, { background: [] }, { align: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
      { font: [] },
    ],
    ["link", "video"],
  ],
  clipboard: { matchVisual: false },
};

const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  // "image",
  "video",
  "color",
  "background",
  "code-block",
  "align",
];

const tooltipStyles = {
  color: "#58B1D3",
  background: "none",
  margin: 0,
  padding: 0,
  border: "none",
  cursor: "pointer",
  fontWeight: 400,
  marginLeft: "8px",
  marginBottom: "3px",
};

const removeTags = (str) => {
  if (str === null || str === "") {
    return "";
  } else {
    str = str.toString();
  }

  // Regular expression to identify HTML tags in
  // the input string. Replacing the identified
  // HTML tag with a null string.
  return str.replace(/(<([^>]+)>)/gi, "");
};

const MarketPlaceListing = ({ step, setStep, partnerDetails, setPartnerDetails }) => {
  const {
    marketplaceBackgroundImage,
    setMarketplaceBackgroundImage,
    promotionalImage1,
    setPromotionalImage1,
    promotionalImage2,
    setPromotionalImage2,
    promotionalImage3,
    automaticRegistrationHandshakeIdx,
    setPromotionalImage3,
    description,
    setDescription,
    thankYouNote,
    setThankYouNote,
    contentConfirmationEmail,
    setContentConfirmationEmail,
    categoryIndex,
    setCategoryIndex,
    setAutomaticRegistrationHandshakeIdx,
    confirmationImage,
    setConfirmationImage,
    selectedApplication,
    marketPlaceListingValues,
    setMarketPlaceListingValues,
    setPartnerlogoImage,
    partnerlogoImage,
    apiLicenseValue,
    selectedFreshdeskOptionValue,
    setSelectedFreshdeskOptionValue,
    needSikkaAppsLicense,
    setNeedSikkaAppsLicense,
    partnerTagline,
    getApplicationInfomation,
    isEditMode,
    onlyOneTimeFill,
    setOnlyOneTimeFill,
  } = useContext(PublishAppContext);
  const { loginUserDetails, isDark } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [headlineforAI, setHeadlineForAI] =useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState("");

  const [termsOfServiceUrl, setTermsOfServiceUrl] = useState(
    marketPlaceListingValues.termsOfService || "URL"
  );
  const [cancellationPolicyUrl, setCancellationPolicyUrl] = useState(
    marketPlaceListingValues.cancellationPolicy || "URL"
  );
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState(
    marketPlaceListingValues.privacyPolicy || "URL"
  );
  const [contactUsUrl, setContactUsUrl] = useState(
    marketPlaceListingValues.contactUs || "URL"
  );

  const {
    register,
    handleSubmit,
    errors,
    unregister,
    setError,
    setValue,
    clearError,
    watch,
    getValues,
    reset,
  } = useForm();

  const emailFieldsInitialized = useRef(false);

  const category = [
    "Business Intelligence",
    "Acquire & Retain",
    "Client Financing",
    "Financial Health",
    "Manufacturer and Distributor",
    "Lab Services",
  ];

  const messages = [
  "Working on it... Hang tight!",
  "Autogenerating the text and images...",
  "Processing your request...",
  "Please wait for sometime...",
];
  const [loadingMessage, setLoadingMessage] = useState(messages[0]);

  const [catagoryDefaultValue, setCatagoryDefaultValue] = useState({
    value: 0,
    label: "Buiness Intelligence",
  });

  const automaticRegistrationHandshake = ["Yes", "No"];
  const [defaultSelectedHandshake, setDefaultSelectedHandshake] = useState({
    value: 0,
    label: "Yes",
  });

  const FreshdeskDeskOptions = [
    {
      label: "Yes",
      value: "Yes",
    },
    {
      label: "No",
      value: "No",
    },
  ];

  const sampleInfo = [
    "Package/Source",
    "Master Customer ID",
    "UserName",
    "Speciality",
    "Postal Code",
    "Practice Phone Number",
    "Practice City",
    "Practice State",
    "Practice Country",
    "First Name",
    "Last Name",
    "Email Address",
    "Order #",
    "Partner Service Name",
    "Partner Service SKU Name",
    "Partner Service SKU Price",
    "Status",
    "Purchase Date",
    "Cancel Date",
    "Partner Registration ID",
    "Practice Name",
    "Practice Street Address",
  ];

  const selectStyles = {
    control: (base) => ({
      ...base,
      fontSize: "12px",
      "min-height": "33px",
      height: "33px",
    }),
    menu: (base) => ({
      ...base,
      fontSize: "12px",
    }),
  };

  useEffect(() => {
    setValue(
      "redirectToConfirmationPage",
      marketPlaceListingValues.redirectToConfirmationPage
    );

    const getSessionData = sessionStorage.getItem("publish-app-details")
      ? JSON.parse(sessionStorage.getItem("publish-app-details"))
      : {};

    if (
      getSessionData.termsOfService &&
      getSessionData.cancellationPolicy &&
      getSessionData.privacyPolicy &&
      getSessionData.contactUs
    ) {
      setTermsOfServiceUrl(getSessionData.termsOfService);
      setCancellationPolicyUrl(getSessionData.cancellationPolicy);
      setPrivacyPolicyUrl(getSessionData.privacyPolicy);
      setContactUsUrl(getSessionData.contactUs);
    }
  }, []);

  useEffect(() => {
    if (step == 2) {
      const getSessionData = sessionStorage.getItem("publish-app-details")
        ? JSON.parse(sessionStorage.getItem("publish-app-details"))
        : {};
      let getValueKeys = Object.keys(getSessionData);
      getValueKeys.map((item) => {
        register(`${item}`);
        setValue(`${item}`, getSessionData[item]);
      });
    }
  }, [step]);

  const handleMarketPlaceListing = (values) => {
    setMarketPlaceListingValues(values);
    sessionStorage.setItem("publish-app-details", JSON.stringify(values));
    setStep(step + 1);
  };

  const watchData = watch();

  useEffect(() => {
    sessionStorage.setItem("publish-app-details", JSON.stringify(watchData));
  }, [Object.values(watchData)]);

  const getSessionData = sessionStorage.getItem("publish-app-details")
    ? JSON.parse(sessionStorage.getItem("publish-app-details"))
    : {};
  useEffect(() => {
    if (
      watch("redirectToConfirmationPage") === "Yes" ||
      getSessionData?.redirectToConfirmationPage === "Yes"
    ) {
      if (getSessionData["thankYouNotesAfterPurchase"]) {
        setValue(
          "thankYouNotesAfterPurchase",
          getSessionData["thankYouNotesAfterPurchase"]
        );
        setThankYouNote(getSessionData["thankYouNotesAfterPurchase"]);
      }
    } else {
      unregister("thankYouNotesAfterPurchase");
      unregister("confirmationPageHeader");

      setValue("thankYouNotesAfterPurchase", "");
      setThankYouNote("");
    }
  }, [
    watch("redirectToConfirmationPage"),
    getSessionData?.redirectToConfirmationPage,
  ]);

  useEffect(() => {
    if (Object.keys(getApplicationInfomation).length > 0 && onlyOneTimeFill) {
      setValue("headline", getApplicationInfomation["head_line"]);
      setValue("description", getApplicationInfomation["description"]);
      setDescription(getApplicationInfomation["description"]);

      const findHandshakeIndex = automaticRegistrationHandshake.findIndex(
        (item) =>
          item.toLowerCase() ==
          getApplicationInfomation[
            "automatic_registration_handshake"
          ]?.toLowerCase()
      );

      setAutomaticRegistrationHandshakeIdx(findHandshakeIndex);
      setDefaultSelectedHandshake({
        value: findHandshakeIndex,
        label: automaticRegistrationHandshake[findHandshakeIndex],
      });

      // freshdesk setting a default value .......

      const findFreshdeskIndex = FreshdeskDeskOptions.findIndex(
        (item) =>
          item.value == getApplicationInfomation["create_support_ticket"]
      );
      const findFreshdeskNotificationIndex = FreshdeskDeskOptions.findIndex(
        (item) => item.value == getApplicationInfomation["support_ticket_email"]
      );

      setSelectedFreshdeskOptionValue({
        ...selectedFreshdeskOptionValue,
        selectedFreshdeskOption: FreshdeskDeskOptions[findFreshdeskIndex],
        selectedFreshdeskOptionForNotification:
          FreshdeskDeskOptions[findFreshdeskNotificationIndex],
      });

      // ........................................
      setValue("postApiFields", getApplicationInfomation["post_api_fields"]);

      setValue("forRegistration", getApplicationInfomation["for_registration"]);
      setValue("forSupport", getApplicationInfomation["for_support"]);

      setValue(
        "postApiBodyType",
        getApplicationInfomation["post_api_body_type"]
      );
      // getApplicationInfomation["img_marketplace_background_image"]
      setMarketplaceBackgroundImage([
        {
          base64: getApplicationInfomation["img_marketplace_background_image"],
          path: null,
          size: null,
          type: "image/png",
        },
      ]);
      setPromotionalImage1([
        {
          base64: getApplicationInfomation["img_promotional1"],
          path: null,
          size: null,
          type: "image/png",
        },
      ]);
      setPromotionalImage2([
        {
          base64: getApplicationInfomation["img_promotional2"],
          path: null,
          size: null,
          type: "image/png",
        },
      ]);
      setPromotionalImage3([
        {
          base64: getApplicationInfomation["img_promotional3"],
          path: null,
          size: null,
          type: "image/png",
        },
      ]);

      if (getApplicationInfomation["img_confirmation_image"]) {
        // setValue("confirmationImage","Upload New")

        setConfirmationImage([
          {
            base64: getApplicationInfomation["img_confirmation_image"],
            path: null,
            size: null,
            type: "image/png",
          },
        ]);
      }

      // category

      const findCatagoryIndex = category.findIndex(
        (item) => item == getApplicationInfomation["category"]
      );
      setCatagoryDefaultValue({
        value: findCatagoryIndex,
        label: category[findCatagoryIndex],
      });

      setValue(
        "postURLForPartnerCancellation",
        getApplicationInfomation["post_url_for_cancellation"]
      );

      setValue(
        "postURLForNewPurchase",
        getApplicationInfomation["post_url_for_new_purchase"]
      );

      const needSikkaAppsLicenseIndex = FreshdeskDeskOptions.findIndex(
        (item) => item.value == getApplicationInfomation["need_api_license"]
      );
      setNeedSikkaAppsLicense(FreshdeskDeskOptions[needSikkaAppsLicenseIndex]);
      // setValue("APILicense", getApplicationInfomation["api_license"]);

      setValue(
        "contentConfirmationEmail",
        getApplicationInfomation["confirmation_email"]
      );
      setContentConfirmationEmail(
        getApplicationInfomation["confirmation_email"]
      );

      setValue(
        "confirmationEmailHeaderLine",
        getApplicationInfomation["confirmation_email_header"]
      );
      setValue(
        "redirectToPartnerPageURL",
        getApplicationInfomation["thank_you_note"]
      );
      // thank you note ......

      setValue(
        "thankYouNotesAfterPurchase",
        getApplicationInfomation["thank_you_note"]
      );
      setThankYouNote(getApplicationInfomation["thank_you_note"]);

      // .....................
      setValue(
        "confirmationPageHeader",
        getApplicationInfomation["thank_you_note_header"]
      );
      if (
        getApplicationInfomation["confirmation_page_type"] ==
        "Confirmation Page"
      ) {
        setValue("redirectToConfirmationPage", "Yes");
      } else {
        setValue(
          "redirectToConfirmationPage",
          "No, Redirect user to my web page"
        );
      }

      setValue("domain", getApplicationInfomation["domain_name"]);

      if (getApplicationInfomation["terms_of_service"] && getApplicationInfomation["terms_of_service"].trim() !== "") {
        setTermsOfServiceUrl("URL");
        setValue("termsOfService", "URL");
        setValue(
          "termsOfServiceURL",
          getApplicationInfomation["terms_of_service"]
        );
      } else {
        setTermsOfServiceUrl("Do not show");
        setValue("termsOfService", "Do not show");
        setValue("termsOfServiceURL","");
      }

      if (getApplicationInfomation["cancellation_policy"]) {
        setCancellationPolicyUrl("URL");
        setValue("cancellationPolicy", "URL");
        setValue(
          "cancellationPolicyURL",
          getApplicationInfomation["cancellation_policy"]
        );
      } else {
        setCancellationPolicyUrl("Do not show");
        setValue("cancellationPolicy", "Do not show");
        setValue("cancellationPolicyURL", "");
      }
      if (getApplicationInfomation["privacy_policy"] && getApplicationInfomation["privacy_policy"].trim() !== "") {
        setPrivacyPolicyUrl("URL");
        setValue("privacyPolicy", "URL");
        setValue(
          "privacyPolicyURL",
          getApplicationInfomation["privacy_policy"]
        );
      } else {
        setPrivacyPolicyUrl("Do not show");
        setValue("privacyPolicy", "Do not show");
        setValue("privacyPolicyURL", "");
      }

      if (getApplicationInfomation["contact_us"] && getApplicationInfomation["contact_us"].trim() !== "") {
          setContactUsUrl("URL");
          setValue("contactUs", "URL");
          setValue("contactUsURL", getApplicationInfomation["contact_us"]);
      } else {
          setContactUsUrl("Do not show");
          setValue("contactUs", "Do not show");
          setValue("contactUsURL", ""); 
        }

      setMarketPlaceListingValues({
        ...marketPlaceListingValues,
        forRegistration: getApplicationInfomation["for_registration"],
        forSupport: getApplicationInfomation["for_support"],
        contactUs: getApplicationInfomation["contact_us"],
        cancellationPolicy: getApplicationInfomation["cancellation_policy"],
        privacyPolicy: getApplicationInfomation["privacy_policy"],
        termsOfService: getApplicationInfomation["terms_of_service"],
        confirmationImage: getApplicationInfomation["img_confirmation_image"]
          ? "Upload New"
          : "Default",
          confirmationPageHeader:getApplicationInfomation["thank_you_note_header"]
      });
    }
  }, [getApplicationInfomation, onlyOneTimeFill]);

 useEffect(() => {
  const username = partnerDetails?.username || "";
  if (!username) return;

  if (isEditMode && getApplicationInfomation && Object.keys(getApplicationInfomation).length > 0) {
    emailFieldsInitialized.current = true;
    return;
  }

  if (emailFieldsInitialized.current) return;

  const curSupport = getValues("forSupport");
  const curRegistration = getValues("forRegistration");

  const supportIsEmpty = !curSupport || (typeof curSupport === "string" && curSupport.trim() === "");
  const registrationIsEmpty = !curRegistration || (typeof curRegistration === "string" && curRegistration.trim() === "");

  if (supportIsEmpty) {
    setValue("forSupport", username, { shouldDirty: true });
    setMarketPlaceListingValues(prev => ({ ...prev, forSupport: username }));
  }

  if (registrationIsEmpty) {
    setValue("forRegistration", username, { shouldDirty: true });
    setMarketPlaceListingValues(prev => ({ ...prev, forRegistration: username }));
  }

  emailFieldsInitialized.current = true;
}, [partnerDetails?.username, isEditMode, getApplicationInfomation]);

useEffect(() => {
  emailFieldsInitialized.current = false;
}, [selectedApplication?.app_id, getApplicationInfomation]);


const handleAutofillFromAI = () => {
  const allValues = getValues();
  const companyUrl = allValues?.companyUrl ? String(allValues.companyUrl).trim() : "";

  if (!companyUrl)  {
    setAiError("Please enter a company URL first.");
    return;
  }

  setAiLoading(true);
  setAiError("");

  let i = 0;
  setLoadingMessage(messages[0]);
  const msgTimer = setInterval(() => {
    i = (i + 1) % messages.length;
    setLoadingMessage(messages[i]);
  }, 2000);


  let apiParam = {
    appName: companyUrl,
    companyUrl: companyUrl,
  };

  apiCall
    .servertrip("GET", "publish_application_autofill", loginUserDetails, apiParam)
    .then((res) => {
      const data = res?.data?.item || {};

      if (data.head_line) {
        setValue("headline", data.head_line, { shouldDirty: true });
      }

      if (data.description) {
        setDescription(data.description);
        setValue("description", data.description);
      }

      if (data.confirmation_email) {
        setContentConfirmationEmail(data.confirmation_email);
        setValue("contentConfirmationEmail", data.confirmation_email);
      }

      if (data.thank_you_note) {
        setThankYouNote(data.thank_you_note);
        setValue("thankYouNotesAfterPurchase", data.thank_you_note);
      }

      if (data.terms_of_service) {
        setTermsOfServiceUrl(data.terms_of_service);
        setValue("termsOfServiceURL", data.terms_of_service);
      }else {
        setTermsOfServiceUrl("Do not show");
        setValue("termsOfService", "Do not show");
        setValue("termsOfServiceURL","");
      }

      if (data.cancellation_policy) {
        setCancellationPolicyUrl(data.cancellation_policy);
        setValue("cancellationPolicyURL", data.cancellation_policy);
      }else {
        setCancellationPolicyUrl("Do not show");
        setValue("cancellationPolicy", "Do not show");
        setValue("cancellationPolicyURL", "");
      }

      if (data.privacy_policy) {
        setPrivacyPolicyUrl(data.privacy_policy);
        setValue("privacyPolicyURL", data.privacy_policy);
      }else {
        setPrivacyPolicyUrl("Do not show");
        setValue("privacyPolicy", "Do not show");
        setValue("privacyPolicyURL", "");
      }

      if (data.contact_us) {
        setContactUsUrl(data.contact_us);
        setValue("contactUsURL", data.contact_us);
      }else {
          setContactUsUrl("Do not show");
          setValue("contactUs", "Do not show");
          setValue("contactUsURL", ""); 
        }

      if (data.automatic_registration_handshake) {
  const handshakeIndex = automaticRegistrationHandshake.indexOf(
    data.automatic_registration_handshake
  );

  if (handshakeIndex !== -1) {
    setAutomaticRegistrationHandshakeIdx(handshakeIndex);
    setValue("automatic_registration_handshake", data.automatic_registration_handshake);
  }
}
  if (data.domain_name) {
   const domainArr = Array.isArray(data.domain_name) ? data.domain_name : [data.domain_name];
   setMarketPlaceListingValues(prev => ({ ...prev, domain: domainArr }));
   setValue("domain", domainArr, { shouldDirty: true });
 }
  
      const wrapImg = (src, filename = "image.png") => {
        if (!src) return null;
        
        let base64String = src;
        if (!src.startsWith('data:')) {
          base64String = `data:image/png;base64,${src}`;
        }
        
        return [{
          base64: base64String,
          path: filename,
          size: Math.round(base64String.length * 0.75),
          type: "image/png"
        }];
      };

      
      if (data.img_marketplace_background_image) {
        const wrappedImg = wrapImg(data.img_marketplace_background_image, "marketplace_bg.png");
        if (wrappedImg) {
          setMarketplaceBackgroundImage(wrappedImg);
          setValue("marketPlaceImage", true);
        }
      }

      
      if (data.img_promotional1) {
        const wrappedImg = wrapImg(data.img_promotional1, "promotional_1.png");
        if (wrappedImg) {
          setPromotionalImage1(wrappedImg);
          setValue("promotionalImage1", true);
        }
      }

      
      if (data.img_promotional2) {
        const wrappedImg = wrapImg(data.img_promotional2, "promotional_2.png");
        if (wrappedImg) {
          setPromotionalImage2(wrappedImg);
          setValue("promotionalImage2", true);
        }
      }

      
      if (data.img_promotional3) {
        const wrappedImg = wrapImg(data.img_promotional3, "promotional_3.png");
        if (wrappedImg) {
          setPromotionalImage3(wrappedImg);
          setValue("promotionalImage3", true);
        }
      }

      setMarketPlaceListingValues(prev => ({
            ...prev,
           forRegistration: partnerDetails.username,
           forSupport: partnerDetails.username          
      }));

      setValue("forRegistration", partnerDetails?.username || "", { shouldDirty: true });
      setValue("forSupport",      partnerDetails?.username || "", { shouldDirty: true });
      
      clearInterval(msgTimer);
      setLoadingMessage(messages[0]);
      setAiLoading(false);
    },
    (err) => {
      console.error("AI Autofill Error:", err);
      setAiError("Failed to autofill from AI");
      clearInterval(msgTimer);
      setLoadingMessage(messages[0]);
      setAiLoading(false);
    }
  );
};

  return (
    <Form onSubmit={handleSubmit(handleMarketPlaceListing)}>
      <Card>
        <SikkaCardHeader className="fs-1" title={"Application Details"} />
        <CardBody>
          <Col>
            <Row className="mt-3">
              <Col>
                <Col>
                  <p className="font-weight-bold mb-1 fs-0">
                    Application Name:
                  </p>
                </Col>
                <Col>
                  <p className="mb-3 fs--1">{selectedApplication?.app_name}</p>
                </Col>
              </Col>
              <Col>
                <Col>
                  <p className="font-weight-bold mb-1 fs-0">
                    Application Status:
                  </p>
                </Col>
                <Col>
                  <p className="mb-3 fs--1">
                    {selectedApplication?.app_status === "verified"
                      ? "Verified"
                      : "Not Verified"}
                  </p>
                </Col>
              </Col>
              <Col>
                <Col>
                  <p className="font-weight-bold mb-1 fs-0">Service ID:</p>
                </Col>
                <Col>
                  <p className="mb-2 fs--1">{selectedApplication?.publish_app_service_id}</p>
                </Col>
              </Col>
            </Row>
            <Col className="mt-5">
              <FormGroup>
                <Row>
                  <Label className="col-2 d-flex align-items-center">
                    What does your application do?{" "}
                    <OverlayTrigger
                      placement="auto"
                      delay={{ show: 200, hide: 200 }}
                      overlay={
                        <Tooltip>Please Enter Your Company URL.</Tooltip>
                      }
                    >
                      <Button style={tooltipStyles} className="mr-3">
                        <FontAwesomeIcon size="sm" icon={faQuestionCircle} />
                      </Button>
                    </OverlayTrigger>
                  </Label>

                  <Input
                    name="companyUrl"
                    className={classNames("col-10", "gen-ai-text")}
                    type="textarea"
                    size="sm"
                    placeholder="Please enter your company URL..."
                    innerRef={register({
                      pattern: {
                        value: /^[^\s]+(\s+[^\s]+)*$/,
                      },
                    })}
                  />
                </Row>

                <Row className="mt-3">
                  <Col className="col-12">
                    {aiError && (
                      <div className="text-danger mb-2 text-center" role="alert">
                        {aiError}
                      </div>
                    )}

                    <div className="d-flex justify-content-center">
                      <Button
                        variant="outline-danger"
                        disabled={!String(watch("companyUrl") || "").trim() || aiLoading}
                        type="button"
                        onClick={handleAutofillFromAI}
                        style={{
                          alignItems: "center",
                          display: isEditMode ? "none" : "inline-flex",
                        }}
                      >
                        {aiLoading ? (
                          "Please wait..."
                        ) : (
                          <span style={{ marginLeft: "8px" }}>
                            Generate with AI <FontAwesomeIcon icon={faWandSparkles} className="ml-1" />
                          </span>
                        )}
                      </Button>
                    </div>

                    {aiLoading && (
                      <div className="text-muted mt-2 text-center" style={{ fontStyle: "italic" }}>
                        {loadingMessage}
                      </div>
                    )}
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Label className="col-2 d-flex align-items-center">
                    Headline:{" "}
                    <span style={{ color: "#e63757", marginLeft: "3px" }}>
                      *
                    </span>
                    <OverlayTrigger
                      placement="auto"
                      delay={{ show: 200, hide: 200 }}
                      overlay={
                        <Tooltip id="headline-tooltip">
                          See you headlines look like visit
                          <a href="https://www.sikkasoft.com">
                            https://www.sikkasoft.com
                          </a>{" "}
                          for more details.
                          <Image
                            className=""
                            fluid
                            alt="headline"
                            src={HeadlineTooltip}
                            height="200px"
                            width="200px"
                          />
                        </Tooltip>
                      }
                    >
                      <Button
                        id="headline-tooltip"
                        style={tooltipStyles}
                        className="mr-3"
                      >
                        <FontAwesomeIcon size="sm" icon={faQuestionCircle} />
                      </Button>
                    </OverlayTrigger>
                  </Label>

                  <Input
                    className={classNames("col-10", {
                      "border-danger": errors["headline"]?.message,
                    })}
                    type="text"
                    id="headline"
                    size="sm"
                    name="headline"
                    placeholder="Your application headline on sikka marketplace"
                    defaultValue={marketPlaceListingValues.headline}
                    onChange={(e) => {
                      setValue("headline", e.target.value, { shouldDirty: true });
                    }}
                    innerRef={register({
                      required: "Headline is required",
                      pattern: {
                        value: /^[^\s]+(\s+[^\s]+)*$/,
                        message: "Invalid Headline",
                      },
                    })}
                  />
                  <SikkaError
                    error={errors["headline"]?.message}
                    className="mt-1"
                  />
                </Row>
              </FormGroup>
            </Col>
          

            <Col className="mt-5">
              <FormGroup
                as={Row}
                className="mb-3 align-items-center"
                controlId="formHorizontalEmail"
              >
                <Row>
                  <Label className="col-2 d-flex align-items-center">
                    Description:{" "}
                    <span style={{ color: "#e63757", marginLeft: "3px" }}>
                      *
                    </span>
                    <OverlayTrigger
                      placement="auto"
                      delay={{ show: 200, hide: 200 }}
                      overlay={
                        <Tooltip id="description-tooltip">
                          See how description look like visit{" "}
                          <a href="https://www.sikkasoft.com">
                            https://www.sikkasoft.com
                          </a>{" "}
                          and click on any services/card. You will see
                          description on application.
                          <Image
                            className=""
                            fluid
                            src={DescriptionTooltip}
                            height="265px"
                            width="380px"
                          />
                        </Tooltip>
                      }
                    >
                      <Button
                        id="description-tooltip"
                        style={tooltipStyles}
                        className="mr-3"
                      >
                        <FontAwesomeIcon size="sm" icon={faQuestionCircle} />
                      </Button>
                    </OverlayTrigger>
                  </Label>
                  <Col className="p-0" sm={10}>
                    <ReactQuill
                      onChange={(value) => {
                        setDescription(value);
                        setValue("description", value);
                      }}
                      modules={modules}
                      formats={formats}
                      style={{
                        border: "1px solid #d8e2ef",
                        borderRadius: "0.2rem",
                      }}
                      {...register("description", {
                        required: "Description is Required.",

                        validate: () => {
                          return removeTags(description) ? true : false;
                        },
                      })}
                      value={description}
                      // defaultValue={`${description}`}
                      // {...register("description", {
                      //   required: "Description is required",
                      // })}
                    />
                    {errors.description ? (
                      <SikkaError
                        error={
                          errors["description"].message
                            ? errors["description"].message
                            : "Description is Required."
                        }
                        className="mt-1"
                      />
                    ) : (
                      <div />
                    )}
                  </Col>
                </Row>
              </FormGroup>
            </Col>
          </Col>
          {/* <Row>
          <Col xs={12} sm={3}>
            <p className="font-weight-bold mb-1">Description</p>
          </Col>
          <Col>
            <QuillEditor value={content} onChange={setContent} />
          </Col>
        </Row> */}

          <SikkaCardHeader className="fs-1" title={"Graphic Assets"} />

          <Col className="mt-5">
            <FormGroup as={Row} controlId="formHorizontalEmail">
              <FormLabel style={{ fontSize: "13px" }} column sm={5}>
                Marketplace Background Image:
                <OverlayTrigger
                  placement="auto"
                  delay={{ show: 200, hide: 200 }}
                  overlay={
                    <Tooltip id="marketplace_background_image-tooltip">
                      See how background image look like visit
                      <a href="https://www.sikkasoft.com">
                        https://www.sikkasoft.com
                      </a>{" "}
                      for more details.
                      <Image
                        className=""
                        fluid
                        src={Marketplacebackgroundtooltipimage}
                        height="265px"
                        width="380px"
                      />
                    </Tooltip>
                  }
                >
                  <Button
                    id="marketplace_background_image-tooltip"
                    style={tooltipStyles}
                    className="mr-3"
                  >
                    <FontAwesomeIcon size="sm" icon={faQuestionCircle} />
                  </Button>
                </OverlayTrigger>
              </FormLabel>
              <Col
                md
                className="d-flex justify-content-around align-items-center"
              >
                {isIterableArray(marketplaceBackgroundImage) ? (
                  <Col md="auto" style={{ border: "1px solid #cec9c9" }}>
                    <Avatar
                      size="5xl"
                      rounded={false}
                      src={
                        isIterableArray(marketplaceBackgroundImage)
                          ? marketplaceBackgroundImage[0]?.base64 ||
                            marketplaceBackgroundImage[0]?.src
                          : ""
                      }
                    />
                  </Col>
                ) : (
                  <div />
                )}
                <FalconDropzone
                  maxSize={1024 * 1024 * 2}
                  files={marketplaceBackgroundImage}
                  onChange={(files) => {
                    setMarketplaceBackgroundImage(files);
                  }}
                  onClick={() => {
                    setValue("marketPlaceImage", true);
                  }}
                  multiple={false}
                  accept="image/*"
                  placeholder={
                    <div className="d-flex flex-column align-items-center">
                      <Flex justifyContent="center">
                        <img
                          src={cloudUpload}
                          alt=""
                          width={25}
                          className="me-2"
                        />
                        <p className="fs-0 mb-0 text-700">
                          Upload your profile picture
                        </p>
                      </Flex>
                      <p className="mb-0 text-400">
                        Note: Image size should be 345W * 237H
                      </p>
                    </div>
                  }
                  {...register("marketPlaceImage", {
                    required: isEditMode
                      ? false
                      : "MarketPlace Background Image is required",
                    validate: () => {
                      return marketplaceBackgroundImage?.[0]?.base64
                        ? true
                        : false;
                    },
                  })}
                />
              </Col>
              {marketplaceBackgroundImage?.[0]?.base64 ? (
                <div />
              ) : (
                <SikkaError
                  error={errors["marketPlaceImage"]?.message}
                  className="mt-1"
                />
              )}
            </FormGroup>
          </Col>
          <Col className="mt-5">
            <FormGroup as={Row} controlId="formHorizontalEmail">
              <FormLabel style={{ fontSize: "13px" }} column sm={12}>
                Promotional Image:
                <OverlayTrigger
                  placement="auto"
                  delay={{ show: 200, hide: 200 }}
                  overlay={
                    <Tooltip id="promotional_image-tooltip">
                      See how promotional image look like visit
                      <a href="https://www.sikkasoft.com">
                        https://www.sikkasoft.com
                      </a>{" "}
                      for more details.
                      <Image
                        className=""
                        fluid
                        src={Promotionaltooltipimage}
                        height="265px"
                        width="380px"
                      />
                    </Tooltip>
                  }
                >
                  <Button
                    id="promotional_image-tooltip"
                    style={tooltipStyles}
                    className="mr-3"
                  >
                    <FontAwesomeIcon size="sm" icon={faQuestionCircle} />
                  </Button>
                </OverlayTrigger>
              </FormLabel>
              <Col
                md
                className="d-flex justify-content-around align-items-center"
              >
                <FalconDropzone
                  maxSize={1024 * 1024 * 2}
                  files={promotionalImage1}
                  onChange={(files) => {
                    setPromotionalImage1(files);
                    console.log("Promotional Image..",files);
                  }}
                  onClick={() => {
                    setValue("promotionalImage1", true);
                  }}
                  multiple={false}
                  accept="image/*"
                  placeholder={
                    <div className="d-flex flex-column align-items-center mb-1">
                      <Flex justifyContent="center">
                        <img
                          src={cloudUpload}
                          alt=""
                          width={25}
                          className="me-2"
                        />
                        <p className="fs-0 mb-0 text-700">Upload Image 1</p>
                      </Flex>
                    </div>
                  }
                  {...register("promotionalImage1", {
                    required: isEditMode
                      ? false
                      : "Promotional Image 1 is required",
                    validate: () => {
                      return promotionalImage1?.[0]?.base64 ? true : false;
                    },
                  })}
                />
                {isIterableArray(promotionalImage1) ? (
                  <Col md="auto" style={{ border: "1px solid #cec9c9" }}>
                    <Avatar
                      size="4xl"
                      rounded="false"
                      src={
                        isIterableArray(promotionalImage1)
                          ? promotionalImage1[0]?.base64 ||
                            promotionalImage1[0]?.src
                          : ""
                      }
                    />
                  </Col>
                ) : (
                  <div />
                )}
              </Col>
              {promotionalImage1?.[0]?.base64 ? (
                <div />
              ) : (
                <SikkaError
                  error={errors["promotionalImage1"]?.message}
                  className="mt-1"
                />
              )}
              <Col
                md
                className="d-flex justify-content-around align-items-center mt-3"
              >
                <FalconDropzone
                  maxSize={1024 * 1024 * 2}
                  files={promotionalImage2}
                  onChange={(files) => {
                    setPromotionalImage2(files);
                  }}
                  onClick={() => {
                    setValue("promotionalImage2", true);
                  }}
                  multiple={false}
                  accept="image/*"
                  placeholder={
                    <div className="d-flex flex-column align-items-center mb-1">
                      <Flex justifyContent="center">
                        <img
                          src={cloudUpload}
                          alt=""
                          width={25}
                          className="me-2"
                        />
                        <p className="fs-0 mb-0 text-700">Upload Image 2</p>
                      </Flex>
                    </div>
                  }
                  {...register("promotionalImage2", {
                    required: isEditMode
                      ? false
                      : "Promotional Image 2 is required",
                    validate: () => {
                      return promotionalImage2?.[0]?.base64 ? true : false;
                    },
                  })}
                />
                {isIterableArray(promotionalImage2) ? (
                  <Col md="auto" style={{ border: "1px solid #cec9c9" }}>
                    <Avatar
                      size="4xl"
                      rounded="false"
                      src={
                        isIterableArray(promotionalImage2)
                          ? promotionalImage2[0]?.base64 ||
                            promotionalImage2[0]?.src
                          : ""
                      }
                    />
                  </Col>
                ) : (
                  <div />
                )}
              </Col>
              {promotionalImage2?.[0]?.base64 ? (
                <div />
              ) : (
                <SikkaError
                  error={errors["promotionalImage2"]?.message}
                  className="mt-1"
                />
              )}
              <Col
                md
                className="d-flex justify-content-around align-items-center mt-3"
              >
                <FalconDropzone
                  maxSize={1024 * 1024 * 2}
                  files={promotionalImage3}
                  onChange={(files) => {
                    setPromotionalImage3(files);
                  }}
                  onClick={() => {
                    setValue("promotionalImage3", true);
                  }}
                  multiple={false}
                  accept="image/*"
                  placeholder={
                    <div className="d-flex flex-column align-items-center mb-1">
                      <Flex justifyContent="center">
                        <img
                          src={cloudUpload}
                          alt=""
                          width={25}
                          className="me-2"
                        />
                        <p className="fs-0 mb-0 text-700">Upload Image3</p>
                      </Flex>
                    </div>
                  }
                  {...register("promotionalImage3", {
                    required: isEditMode
                      ? false
                      : "Promotional Image 3 is required",
                    validate: () => {
                      return promotionalImage3?.[0]?.base64 ? true : false;
                    },
                  })}
                />
                {isIterableArray(promotionalImage3) ? (
                  <Col md="auto" style={{ border: "1px solid #cec9c9" }}>
                    <Avatar
                      size="4xl"
                      rounded="false"
                      src={
                        isIterableArray(promotionalImage3)
                          ? promotionalImage3[0]?.base64 ||
                            promotionalImage3[0]?.src
                          : ""
                      }
                    />
                  </Col>
                ) : (
                  <div />
                )}
              </Col>
              {promotionalImage3?.[0]?.base64 ? (
                <div />
              ) : (
                <SikkaError
                  error={errors["promotionalImage3"]?.message}
                  className="mt-1"
                />
              )}
            </FormGroup>
          </Col>

          {/* <SikkaCardHeader className="fs-1" title={"Categorization"} />

          <FormGroup className="d-flex flex-column flex-sm-row flex-md-row flex-lg-row mt-3 mb-3 align-items-center">
            <FormLabel
              className="d-flex align-items-center mr-3"
              style={{ fontSize: "13px" }}
              column
              sm={2}
            >
              Category
              <OverlayTrigger
                placement="auto"
                delay={{ show: 200, hide: 200 }}
                overlay={
                  <Tooltip id="category-tooltip">
                    See how category look like visit
                    <a href="https://www.sikkasoft.com">
                      https://www.sikkasoft.com
                    </a>{" "}
                    for more details.
                    <Image
                      className=""
                      fluid
                      src={Categorytooltipimage}
                      height="265px"
                      width="380px"
                    />
                  </Tooltip>
                }
              >
                <Button
                  id="category-tooltip"
                  style={tooltipStyles}
                  className="mr-3"
                >
                  <FontAwesomeIcon size="sm" icon={faQuestionCircle} />
                </Button>
              </OverlayTrigger>
            </FormLabel>

            <Col sm={8}>
              <Select
                placeholder="Select a category"
                styles={selectStyles}
                options={category.map((option, index) => {
                  return {
                    value: index,
                    label: option,
                  };
                })}
                defaultValue={catagoryDefaultValue}
                // value={{ value: categoryIndex, label: category[categoryIndex] }}
                onChange={(selectedOption) =>
                  setCategoryIndex(selectedOption.value)
                }
              />
            </Col>
          </FormGroup> */}

          <FormGroup
            className="d-flex flex-column flex-sm-row flex-md-row flex-lg-row mb-4 align-items-center mt-5"
            controlId="formHorizontalEmail"
          >
            {/* <div> */}

            <FormLabel
              className="d-flex align-items-center mr-3"
              style={{ fontSize: "13px" }}
              column
              sm={2}
            >
              Domain:{" "}
              <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
            </FormLabel>

            <div>
              <div>
                <Col
                  sm={12}
                  className="d-flex justify-content-between flex-wrap"
                >
                  <div className="mr-4 ml-2">
                    <Input
                      type="checkbox"
                      id="Dental-domain"
                      label="Dental"
                      name="domain"
                      value="Dental"
                      defaultChecked={marketPlaceListingValues?.domain?.includes(
                        "Dental"
                      )}
                      innerRef={register({
                        required: "Domain is required",
                        validate: () => {
                          return watch("domain").length > 0;
                        },
                      })}
                    />
                    <FormLabel>Dental</FormLabel>
                  </div>
                  <div className="mr-4 ml-2">
                    <Input
                      type="checkbox"
                      id="Veterinary-domain"
                      label="Veterinary"
                      name="domain"
                      value="Veterinary"
                      innerRef={register({
                        required: "Domain is required",
                        validate: () => {
                          return watch("domain").length > 0;
                        },
                      })}
                      defaultChecked={marketPlaceListingValues?.domain?.includes(
                        "Veterinary"
                      )}
                    />
                    <FormLabel>Veterinary</FormLabel>
                  </div>
                  <div className="mr-4 ml-2">
                    <Input
                      type="checkbox"
                      id="Optometry"
                      label="Optometry"
                      name="domain"
                      value="Optometry"
                      innerRef={register({
                        required: "Domain is required",
                        validate: () => {
                          return watch("domain").length > 0;
                        },
                      })}
                      defaultChecked={marketPlaceListingValues?.domain?.includes(
                        "Optometry"
                      )}
                    />
                    <FormLabel>Optometry</FormLabel>
                  </div>
                  <div className="mr-4 ml-2">
                    <Input
                      type="checkbox"
                      id="Audiology"
                      label="Audiology"
                      name="domain"
                      value="Audiology"
                      innerRef={register({
                        required: "Domain is required",
                        validate: () => {
                          return watch("domain").length > 0;
                        },
                      })}
                      defaultChecked={marketPlaceListingValues?.domain?.includes(
                        "Audiology"
                      )}
                    />
                    <FormLabel>Audiology</FormLabel>
                  </div>
                  <div className="mr-4 ml-2">
                    <Input
                      type="checkbox"
                      id="Chiropractic"
                      label="Chiropractic"
                      name="domain"
                      value="Chiropractic"
                      innerRef={register({
                        required: "Domain is required",
                        validate: () => {
                          return watch("domain").length > 0;
                        },
                      })}
                      defaultChecked={marketPlaceListingValues?.domain?.includes(
                        "Chiropractic"
                      )}
                    />
                    <FormLabel>Chiropractic</FormLabel>
                  </div>
                  <div className="mr-4 ml-2">
                    <Input
                      type="checkbox"
                      id="Orthodontics"
                      label="Orthodontic"
                      name="domain"
                      value="Orthodontics"
                      innerRef={register({
                        required: "Domain is required",
                        validate: () => {
                          return watch("domain").length > 0;
                        },
                      })}
                      defaultChecked={marketPlaceListingValues?.domain?.includes(
                        "Orthodontics"
                      )}
                    />
                    <FormLabel>Orthodontics</FormLabel>
                  </div>
                </Col>
              </div>
              <SikkaError error={errors["domain"]?.message} className="mt-1" />
            </div>
          </FormGroup>
          <FormGroup
            className="mb-2 align-items-center"
            controlId="formHorizontalEmail"
          >
            <FormLabel
              className="d-flex align-items-center mr-3"
              style={{ fontSize: "13px" }}
              column
              sm={3}
            >
              Terms of service:{" "}
              <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
            </FormLabel>

            <Row>
              <Col className="d-flex align-items-center">
                <Row className="ml-3 p-0">
                  <FormGroup check className="" controlId="versions">
                    <Input
                      type="radio"
                      id="termsOfService-URL"
                      label="URL"
                      name="termsOfService"
                      value="URL"
                      defaultChecked={
                        marketPlaceListingValues.termsOfService
                          ? marketPlaceListingValues.termsOfService === "URL"
                          : true
                      }
                      innerRef={register()}
                      onClick={(e) => setTermsOfServiceUrl("URL")}
                    />
                    <FormLabel>URL</FormLabel>
                  </FormGroup>
                  <FormGroup
                    className="ml-0 ml-sm-3 ml-md-3 ml-lg-5 ml-xl-5"
                    check
                  >
                    <Input
                      inline
                      type="radio"
                      id="termsOfService-DoNotShow"
                      label="Do not Show"
                      name="termsOfService"
                      value="Do not show"
                      defaultChecked={
                        marketPlaceListingValues.termsOfService
                          ? marketPlaceListingValues.termsOfService ===
                            "Do not show"
                          : false
                      }
                      innerRef={register()}
                      onClick={(e) => setTermsOfServiceUrl("Do not show")}
                    />
                    <FormLabel>Do not show</FormLabel>
                  </FormGroup>
                </Row>
                <SikkaError
                  error={errors["termsOfService"]?.message}
                  className="mt-1"
                />
              </Col>
              {termsOfServiceUrl === "URL" ? (
                <Col sm={8}>
                  <SikkaInput
                    name="termsOfServiceURL"
                    size="sm"
                    defaultValue={marketPlaceListingValues.termsOfServiceURL}
                    id="termsOfServiceURL"
                    placeholder="Terms of Service URL"
                    innerRef={register({
                      required: "Terms of Service URL is required",
                      pattern: {
                        value: /^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)+([/?].*)?$/i,
                        message: "Invalid Terms of Service URL",
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              ) : (
                <Col sm={8} />
              )}
            </Row>
          </FormGroup>

          <FormGroup
            as={Row}
            className="mb-2 align-items-center"
            controlId="formHorizontalEmail"
          >
            <FormLabel
              className="d-flex align-items-center mr-3"
              style={{ fontSize: "13px" }}
              column
              sm={3}
            >
              Cancellation Policy:{" "}
              <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
            </FormLabel>

            <Row>
              <Col className="d-flex align-items-center">
                <Row className="ml-3 p-0">
                  <FormGroup check className="" controlId="versions">
                    <Input
                      type="radio"
                      id="cancellationPolicy-URL"
                      label="URL"
                      name="cancellationPolicy"
                      value="URL"
                      defaultChecked={
                        marketPlaceListingValues.cancellationPolicy
                          ? marketPlaceListingValues.cancellationPolicy ===
                            "URL"
                          : true
                      }
                      innerRef={register()}
                      onClick={(e) => setCancellationPolicyUrl("URL")}
                    />
                    <FormLabel>URL</FormLabel>
                  </FormGroup>
                  <FormGroup
                    className="ml-0 ml-sm-3 ml-md-3 ml-lg-5 ml-xl-5"
                    check
                  >
                    <Input
                      inline
                      type="radio"
                      id="cancellationPolicy-DoNotShow"
                      label="Do not Show"
                      name="cancellationPolicy"
                      value="Do not show"
                      defaultChecked={
                        marketPlaceListingValues.cancellationPolicy
                          ? marketPlaceListingValues.cancellationPolicy ===
                            "Do not show"
                          : false
                      }
                      innerRef={register()}
                      onClick={(e) => setCancellationPolicyUrl("Do not show")}
                    />
                    <FormLabel>Do not show</FormLabel>
                  </FormGroup>
                </Row>
                <SikkaError
                  error={errors["cancellationPolicy"]?.message}
                  className="mt-1"
                />
              </Col>
              {cancellationPolicyUrl === "URL" ? (
                <Col sm={8}>
                  <SikkaInput
                    name="cancellationPolicyURL"
                    size="sm"
                    defaultValue={
                      marketPlaceListingValues.cancellationPolicyURL
                    }
                    id="cancellationPolicyURL"
                    placeholder="Cancellation Policy URL"
                    innerRef={register({
                      required: "Cancellation Policy URL is required",
                      pattern: {
                        value: /^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)+([/?].*)?$/i,
                        message: "Invalid Cancellation Policy URL",
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              ) : (
                <Col sm={8} />
              )}
            </Row>
          </FormGroup>

          <FormGroup
            as={Row}
            className="mb-2 align-items-center"
            controlId="formHorizontalEmail"
          >
            <FormLabel
              className="d-flex align-items-center mr-3"
              style={{ fontSize: "13px" }}
              column
              sm={3}
            >
              Privacy Policy:{" "}
              <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
            </FormLabel>

            <Row>
              <Col className="d-flex align-items-center">
                <Row className="ml-3 p-0">
                  <FormGroup check className="" controlId="versions">
                    <Input
                      type="radio"
                      id="privacyPolicy-URL"
                      label="URL"
                      name="privacyPolicy"
                      value="URL"
                      defaultChecked={
                        marketPlaceListingValues.privacyPolicy
                          ? marketPlaceListingValues.privacyPolicy === "URL"
                          : true
                      }
                      innerRef={register()}
                      onClick={(e) => setPrivacyPolicyUrl("URL")}
                    />
                    <FormLabel>URL</FormLabel>
                  </FormGroup>
                  <FormGroup
                    className="ml-0 ml-sm-3 ml-md-3 ml-lg-5 ml-xl-5"
                    check
                  >
                    <Input
                      inline
                      type="radio"
                      id="privacyPolicy-DoNotShow"
                      label="Do not Show"
                      name="privacyPolicy"
                      value="Do not show"
                      defaultChecked={
                        marketPlaceListingValues.privacyPolicy
                          ? marketPlaceListingValues.privacyPolicy ===
                            "Do not show"
                          : false
                      }
                      innerRef={register()}
                      onClick={(e) => setPrivacyPolicyUrl("Do not show")}
                    />
                    <FormLabel>Do not show</FormLabel>
                  </FormGroup>
                </Row>
                <SikkaError
                  error={errors["privacyPolicy"]?.message}
                  className="mt-1"
                />
              </Col>
              {privacyPolicyUrl === "URL" ? (
                <Col sm={8}>
                  <SikkaInput
                    name="privacyPolicyURL"
                    size="sm"
                    id="privacyPolicyURL"
                    defaultValue={marketPlaceListingValues.privacyPolicyURL}
                    placeholder="Privacy Policy URL"
                    innerRef={register({
                      required: "Privacy Policy URL is required",
                      pattern: {
                        value: /^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)+([/?].*)?$/i,
                        message: "Invalid Privacy Policy URL",
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              ) : (
                <Col sm={8} />
              )}
            </Row>
          </FormGroup>

          <FormGroup
            as={Row}
            className="mb-2 align-items-center"
            controlId="formHorizontalEmail"
          >
            <FormLabel
              className="d-flex align-items-center mr-3"
              style={{ fontSize: "13px" }}
              column
              sm={3}
            >
              Contact Us:{" "}
              <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
            </FormLabel>

            <Row>
              <Col className="d-flex align-items-center">
                <Row className="ml-3 p-0">
                  <FormGroup check className="" controlId="versions">
                    <Input
                      type="radio"
                      id="contactUs-URL"
                      label="URL"
                      name="contactUs"
                      value="URL"
                      defaultChecked={
                        marketPlaceListingValues.contactUs
                          ? marketPlaceListingValues.contactUs === "URL"
                          : true
                      }
                      innerRef={register()}
                      onClick={(e) => setContactUsUrl("URL")}
                    />
                    <FormLabel>URL</FormLabel>
                  </FormGroup>
                  <FormGroup
                    className="ml-0 ml-sm-3 ml-md-3 ml-lg-5 ml-xl-5"
                    check
                  >
                    <Input
                      inline
                      type="radio"
                      id="contactUs-DoNotShow"
                      label="Do not Show"
                      name="contactUs"
                      value="Do not show"
                      defaultChecked={
                        marketPlaceListingValues.contactUs
                          ? marketPlaceListingValues.contactUs === "Do not show"
                          : false
                      }
                      innerRef={register()}
                      onClick={(e) => setContactUsUrl("Do not show")}
                    />
                    <FormLabel>Do not show</FormLabel>
                  </FormGroup>
                </Row>
                <SikkaError
                  error={errors["contactUs"]?.message}
                  className="mt-1"
                />
              </Col>
              {contactUsUrl === "URL" ? (
                <Col sm={8}>
                  <SikkaInput
                    name="contactUsURL"
                    size="sm"
                    id="contactUsURL"
                    defaultValue={marketPlaceListingValues.contactUsURL}
                    placeholder="Contact Us URL"
                    innerRef={register({
                      required: "Contact Us URL is required",
                      pattern: {
                        value: /^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)+([/?].*)?$/i,
                        message: "Invalid Contact Us URL",
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              ) : (
                <Col sm={8} />
              )}
            </Row>
          </FormGroup>

          <SikkaCardHeader className="fs-1" title={"Confirmation Email"} />

          <FormGroup
            as={Row}
            className="mt-4 mb-3 align-items-center"
            controlId="formHorizontalEmail"
          >
            <FormLabel
              className="d-sm-flex align-items-center ml-3"
              style={{ fontSize: "13px" }}
              row
              sm={12}
            >
              After signup user should redirect to confirmation page on Sikka
              marketplace?
            </FormLabel>

            <Col sm={12}>
              <Row className="ml-2">
                <FormGroup check className="" controlId="versions">
                  <Input
                    type="radio"
                    id="redirectToConfirmationPage"
                    name="redirectToConfirmationPage"
                    label="Yes"
                    value="Yes"
                    // onClick={() => {
                    //   marketPlaceListingValues["redirectToConfirmationPage"] = "Yes";
                    //   setMarketPlaceListingValues(Object.assign({}, marketPlaceListingValues));
                    // }}
                    defaultChecked={
                      marketPlaceListingValues.redirectToConfirmationPage
                        ? marketPlaceListingValues.redirectToConfirmationPage ===
                          "Yes"
                        : true
                    }
                    innerRef={register()}
                  />
                  <FormLabel>Yes</FormLabel>
                </FormGroup>
                <FormGroup className="ml-5" check>
                  <Input
                    inline
                    type="radio"
                    id="redirectToConfirmationPage"
                    label="No, Redirect user to my web page"
                    name="redirectToConfirmationPage"
                    value="No, Redirect user to my web page"
                    // onClick={() => {
                    //   marketPlaceListingValues["redirectToConfirmationPage"] = "No, Redirect user to my web page";
                    //   setMarketPlaceListingValues(Object.assign({}, marketPlaceListingValues));
                    // }}
                    defaultChecked={
                      marketPlaceListingValues.redirectToConfirmationPage
                        ? marketPlaceListingValues.redirectToConfirmationPage ===
                          "No, Redirect user to my web page"
                        : false
                    }
                    innerRef={register()}
                  />
                  <FormLabel>No, Redirect user to my web page</FormLabel>
                </FormGroup>
              </Row>
            </Col>
          </FormGroup>
          {watch("redirectToConfirmationPage") === "Yes" ? (
            <>
              <FormGroup as={Row} className="mb-3 mt-4 align-items-center">
                <FormLabel
                  className="d-sm-flex align-items-center"
                  style={{ fontSize: "13px" }}
                  column
                  sm={12}
                >
                  Confirmation page header line (Max 100 characters):{" "}
                  <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
                </FormLabel>

                <Col sm={12}>
                  <Input
                    name="confirmationPageHeader"
                    size="sm"
                    id="confirmationPageHeader"
                    defaultValue={
                      marketPlaceListingValues.confirmationPageHeader
                        ? marketPlaceListingValues.confirmationPageHeader
                        : "Thank you for your $servicename$ subscription"
                    }
                    onChange={(e) => {
                      setValue("confirmationPageHeader", e.target.value);
                    }}
                    placeholder="Thank you for your $servicename$ subscription"
                    innerRef={register({
                      required: "Confirmation Page Header Line is required",
                      maxLength: 100,
                    })}
                  />
                  <SikkaError
                    error={errors["confirmationPageHeader"]?.message}
                    className="mt-1"
                  />
                </Col>
              </FormGroup>

              <FormGroup as={Row} className="mb-3 mt-4 align-items-center">
                <FormLabel
                  className="d-sm-flex align-items-center"
                  style={{ fontSize: "13px" }}
                  column
                  sm={12}
                >
                  Below text will be displayed after user successfully purchase
                  your service from marketplace. (Thank you note for user):{" "}
                  <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
                </FormLabel>

                <Col className="p-0 ml-3" sm={11}>
                  <ReactQuill
                    onChange={(value) => {
                      setThankYouNote(value);
                      setValue("thankYouNotesAfterPurchase", value);
                    }}
                    modules={modules}
                    formats={formats}
                    style={{
                      border: "1px solid #d8e2ef",
                      borderRadius: "0.2rem",
                    }}
                    {...register("thankYouNotesAfterPurchase", {
                      required: isEditMode
                        ? false
                        : "Thank you note is required",
                      validate: () => {
                        return removeTags(thankYouNote) ? true : false;
                      },
                    })}
                    value={thankYouNote}
                  />

                  {errors.thankYouNotesAfterPurchase && (
                    <SikkaError
                      error={
                        errors["thankYouNotesAfterPurchase"]?.message
                          ? errors["thankYouNotesAfterPurchase"]?.message
                          : "Thank you note is required"
                      }
                      className="mt-1"
                    />
                  )}
                </Col>
              </FormGroup>

              <FormGroup
                as={Row}
                className="mb-2 mt-2 align-items-center"
                controlId="formHorizontalEmail"
              >
                <FormLabel
                  className="d-sm-flex align-items-center"
                  style={{ fontSize: "13px" }}
                  column
                  sm={12}
                >
                  Confirmation Image:{" "}
                  <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
                </FormLabel>

                <Col sm={3} className="mt-2">
                  <Row className="ml-1 p-0">
                    <FormGroup check className="" controlId="versions">
                      <Input
                        type="radio"
                        id="confirmationImage"
                        label="Default"
                        name="confirmationImage"
                        value="Default"
                        defaultChecked={
                          marketPlaceListingValues.confirmationImage
                            ? marketPlaceListingValues.confirmationImage ===
                              "Default"
                            : true
                        }
                        innerRef={register()}
                        onClick={() => setConfirmationImage("Default")}
                      />
                      <FormLabel>Default</FormLabel>
                    </FormGroup>
                    <FormGroup className="ml-5" check>
                      <Input
                        inline
                        type="radio"
                        id="confirmationImage"
                        label="Upload New"
                        name="confirmationImage"
                        value="Upload New"
                        defaultChecked={
                          marketPlaceListingValues.confirmationImage
                            ? marketPlaceListingValues.confirmationImage ===
                              "Upload New"
                            : false
                        }
                        innerRef={register()}
                        onClick={() => setConfirmationImage("Upload New")}
                      />
                      <FormLabel>Upload New</FormLabel>
                    </FormGroup>
                  </Row>
                  <SikkaError
                    error={errors["confirmation-image"]?.message}
                    className="mt-1"
                  />
                </Col>

                {confirmationImage === "Default" ? (
                  <Col sm={12}>
                    <Avatar
                      size="5xl"
                      rounded="soft"
                      src={
                        Thankyou_MobileIMG
                      }
                    />
                  </Col>
                ) : (
                  <Col className="align-items-center" sm={12}>
                    <FalconDropzone
                      maxSize={1024 * 1024 * 2}
                      files={confirmationImage}
                      onChange={(files) => {
                        setConfirmationImage(files);
                      }}
                      multiple={false}
                      accept="image/*"
                      placeholder={
                        <div className="mb-1" style={{ cursor: "pointer" }}>
                          <Flex>
                            <img
                              src={cloudUpload}
                              alt=""
                              width={25}
                              className="me-2"
                            />
                            <p className="fs--1 mb-0 text-700">
                              Upload confirmation image
                            </p>
                          </Flex>
                        </div>
                      }
                    />
                    <Col md="auto" style={{ border: "1px solid #cec9c9" }}>
                      <Avatar
                        size="5xl"
                        rounded="soft"
                        src={
                          isIterableArray(confirmationImage)
                            ? confirmationImage[0]?.base64 ||
                              confirmationImage[0]?.src
                            : ""
                        }
                      />
                    </Col>
                  </Col>
                )}
              </FormGroup>
            </>
          ) : (
            <>
              <FormGroup as={Row} className="mb-4 align-items-center">
                <FormLabel
                  className="d-sm-flex align-items-center"
                  style={{ fontSize: "13px", marginBottom: "-22px" }}
                  column
                  sm={12}
                >
                  Redirect to partner page URL:{" "}
                  <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
                </FormLabel>

                <Col sm={12}>
                  <SikkaInput
                    name="redirectToPartnerPageURL"
                    size="sm"
                    id="redirectToPartnerPageURL"
                    defaultValue={
                      marketPlaceListingValues.redirectToPartnerPageURL
                    }
                    placeholder="Redirect to partner page URL"
                    innerRef={register({
                      required: "Redirect to partner page URL is required",
                      pattern: {
                        // value: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
                        value: /^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)+([/?].*)?$/i,
                        message: "Invalid POST URL for New Purchase",
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              </FormGroup>
            </>
          )}

          <FormGroup as={Row} className="mb-3 mt-4 align-items-center">
            <FormLabel
              className="d-sm-flex align-items-center"
              style={{ fontSize: "13px", marginBottom: "-22px" }}
              column
              sm={12}
            >
              Confirmation email header line (Max 100 characters):{" "}
              <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
            </FormLabel>

            <Col sm={12}>
              <SikkaInput
                name="confirmationEmailHeaderLine"
                size="sm"
                id="confirmationEmailHeaderLine"
                defaultValue={
                  marketPlaceListingValues.confirmationEmailHeaderLine
                    ? marketPlaceListingValues.confirmationEmailHeaderLine
                    : "Thank you for your $servicename$ subscription"
                }
                placeholder="Thank you for your $servicename$ subscription"
                innerRef={register({
                  required: "Confirmation Email Header Line is required",
                  maxLength: 100,
                })}
                errors={errors}
              />
            </Col>
          </FormGroup>
          <FormGroup as={Row} className="mb-3 mt-4 align-items-center">
            <FormLabel
              className="d-sm-flex align-items-center"
              style={{ fontSize: "13px" }}
              column
              sm={12}
            >
              Content for on Confirmation Email (sent to customer):
              <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
            </FormLabel>

            {/* <Col sm={12}>
              <QuillEditor
                value={contentConfirmationEmail}
                onChange={setContentConfirmationEmail}
                style={{ border: "1px solid #ccc", borderRadius: "3px", resize: "vertical" }}
              />
            </Col> */}
            <Col className="p-0" sm={12}>
              <ReactQuill
                value={contentConfirmationEmail}
                onChange={(value) => {
                  setContentConfirmationEmail(value);
                  setValue("contentConfirmationEmail", value);
                }}
                modules={modules}
                formats={formats}
                style={{
                  border: "1px solid #d8e2ef",
                  borderRadius: "0.2rem",
                }}
                {...register("contentConfirmationEmail", {
                  required: "Content for on Confirmation Email is required",
                  validate: () => {
                    return removeTags(contentConfirmationEmail) ? true : false;
                  },
                })}
              />
            </Col>
            {errors?.contentConfirmationEmail && (
              <SikkaError
                error={
                  errors["contentConfirmationEmail"].message
                    ? errors["contentConfirmationEmail"].message
                    : "Content for on Confirmation Email is required"
                }
                className="mt-1"
              />
            )}
          </FormGroup>
          <FormGroup as={Row} className="mb-3 mt-4 align-items-center">
            <Col>
              <Row>
                <Col lg={6} sm={12}>
                  <FormLabel
                    className="d-sm-flex align-items-center"
                    style={{ fontSize: "13px" }}
                    sm={12}
                  >
                    Would you allow us to create freshdesk ticket?
                    <span style={{ color: "#e63757", marginLeft: "3px" }}>
                      *
                    </span>
                  </FormLabel>
                  <SikkaSelect
                    placeholder="Select"
                    styles={selectStyles}
                    options={FreshdeskDeskOptions}
                    // defaultValue={
                    //   selectedFreshdeskOptionValue.selectedFreshdeskOption
                    // }
                    value={selectedFreshdeskOptionValue.selectedFreshdeskOption}
                    onChange={(selectedOption) => {
                      setSelectedFreshdeskOptionValue({
                        ...selectedFreshdeskOptionValue,
                        selectedFreshdeskOption: selectedOption,
                      });
                    }}
                  />
                </Col>
                {selectedFreshdeskOptionValue?.selectedFreshdeskOption?.value ==
                "Yes" ? (
                  <>
                    <Col sm={12} lg={6}>
                      <FormLabel
                        className="d-sm-flex align-items-center"
                        style={{ fontSize: "13px" }}
                        sm={12}
                      >
                        Would you like an email notification from freshdesk
                        ticket created?
                        <span style={{ color: "#e63757", marginLeft: "3px" }}>
                          *
                        </span>
                      </FormLabel>
                      <SikkaSelect
                        placeholder="Select"
                        styles={selectStyles}
                        options={FreshdeskDeskOptions}
                        // defaultValue={
                        //   selectedFreshdeskOptionValue.selectedFreshdeskOptionForNotification
                        // }
                        value={
                          selectedFreshdeskOptionValue.selectedFreshdeskOptionForNotification
                        }
                        onChange={(selectedOption) => {
                          setSelectedFreshdeskOptionValue({
                            ...selectedFreshdeskOptionValue,
                            selectedFreshdeskOptionForNotification: selectedOption,
                          });
                        }}
                      />
                    </Col>
                  </>
                ) : (
                  <></>
                )}
              </Row>
            </Col>
          </FormGroup>
          <hr />
          {/* <FormGroup as={Row} className="mb-3 mt-4 align-items-center">
            <Col>
              <Row>
                <Col lg={6} sm={12}>
                  <FormLabel
                    className="d-sm-flex align-items-center"
                    style={{ fontSize: "13px" }}
                    sm={12}
                  >
                    Partner Logo
                    <span style={{ color: "#e63757", marginLeft: "3px" }}>
                      *
                    </span>
                  </FormLabel>
                  <Col>
                    <Row>
                      <Col>
                        <Avatar
                          size="4xl"
                          rounded="false"
                          src={partnerlogoImage}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Col>
                <Col lg={6} sm={12}>
                  <FormLabel
                    className="d-sm-flex align-items-center"
                    style={{ fontSize: "13px", marginBottom: "-13px" }}
                    sm={12}
                  >
                    Partner Tagline
                    <span style={{ color: "#e63757", marginLeft: "3px" }}>
                      *
                    </span>
                  </FormLabel>

                  <SikkaInput
                    name="Partner Tagline"
                    size="sm"
                    id="PartneTagline"
                    placeholder="partner tagline..."
                    innerRef={register()}
                    errors={errors}
                    disabled={true}
                    defaultValue={partnerTagline}
                  />
                </Col>
              </Row>
            </Col>
          </FormGroup>
          <hr /> */}
          <FormGroup as={Row} className="">
            <Col>
              <Row className="">
                <Col lg={6} sm={12}>
                  <FormLabel
                    className="d-sm-flex align-items-center"
                    style={{ fontSize: "13px" }}
                    sm={12}
                  >
                    Need Sikka Apps License?
                    <span style={{ color: "#e63757", marginLeft: "3px" }}>
                      *
                    </span>
                  </FormLabel>
                  <SikkaSelect
                    placeholder="Select"
                    styles={selectStyles}
                    options={FreshdeskDeskOptions}
                    value={needSikkaAppsLicense}
                    onChange={(selectedOption) => {
                      setNeedSikkaAppsLicense(selectedOption);
                    }}
                  />
                </Col>
                {needSikkaAppsLicense?.value == "Yes" ? (
                  <>
                    <Col sm={12} lg={6} className="">
                      <FormLabel
                        className="d-sm-flex align-items-center"
                        style={{ fontSize: "13px", marginBottom: "-13px" }}
                        sm={12}
                      >
                        API License
                        <span style={{ color: "#e63757", marginLeft: "3px" }}>
                          *
                        </span>
                      </FormLabel>
                      <SikkaInput
                        name="APILicense"
                        size="sm"
                        id="APILicense"
                        placeholder="api license..."
                        innerRef={register()}
                        errors={errors}
                        disabled={true}
                        value={apiLicenseValue}
                        style={
                          isDark
                            ? {
                                backgroundColor: "#0b1727",
                                color: "#fff",
                                borderColor: "#344050",
                              }
                            : undefined
                        }
                      />
                    </Col>
                  </>
                ) : (
                  <></>
                )}
              </Row>
            </Col>
          </FormGroup>
          <SikkaCardHeader className="fs-1" title={"Registration Handshake"} />

          <FormGroup
            as={Row}
            className="mb-3 align-items-center mt-2"
            controlId="formHorizontalEmail"
          >
            <FormLabel
              className="d-sm-flex align-items-center mb-1"
              style={{ fontSize: "13px" }}
              column
              sm={12}
            >
              Automatic Registration Handshake
            </FormLabel>

            <Col sm={12}>
              <SikkaSelect
                placeholder="Select"
                styles={selectStyles}
                options={automaticRegistrationHandshake.map((option, index) => {
                  return {
                    value: index,
                    label: option,
                  };
                })}
                defaultValue={defaultSelectedHandshake}
                value={{
                  value: automaticRegistrationHandshakeIdx,
                  label:
                    automaticRegistrationHandshake[
                      automaticRegistrationHandshakeIdx
                    ],
                }}
                onChange={(selectedOption) =>
                  setAutomaticRegistrationHandshakeIdx(selectedOption.value)
                }
              />
            </Col>
          </FormGroup>

          {automaticRegistrationHandshake[automaticRegistrationHandshakeIdx] ===
            "Yes" && (
            <>
              <div className="d-flex mt-4">
                <Col>
                  <FormGroup className="mb-3 align-items-center">
                    <Col className="p-0">
                      <FormLabel
                        className="d-flex align-items-center mb-0"
                        style={{ fontSize: "13px" }}
                      >
                        POST URL for New Purchase:{" "}
                        <span style={{ color: "#e63757", marginLeft: "3px" }}>
                          *
                        </span>
                      </FormLabel>

                      <Col className="p-0" style={{ marginTop: "-13px" }}>
                        <SikkaInput
                          name="postURLForNewPurchase"
                          size="sm"
                          defaultValue={
                            marketPlaceListingValues.postURLForNewPurchase
                          }
                          id="postURLForNewPurchase"
                          placeholder="POST URL for New Purchase"
                          innerRef={register({
                            required: "POST URL for New Purchase is required",
                            pattern: {
                              // value: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
                              value: /^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)+([/?].*)?$/i,
                              message: "Invalid POST URL for New Purchase",
                            },
                          })}
                          errors={errors}
                        />
                      </Col>
                    </Col>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup className="mb-3 align-items-center">
                    <Col className="p-0">
                      <FormLabel
                        className="d-flex align-items-center mb-0"
                        style={{ fontSize: "13px" }}
                      >
                        POST URL for Partner Cancellation:{" "}
                        <span style={{ color: "#e63757", marginLeft: "3px" }}>
                          *
                        </span>
                      </FormLabel>

                      <Col className="p-0" style={{ marginTop: "-13px" }}>
                        <SikkaInput
                          name="postURLForPartnerCancellation"
                          size="sm"
                          defaultValue={
                            marketPlaceListingValues.postURLForPartnerCancellation
                          }
                          id="postURLForPartnerCancellation"
                          placeholder="POST URL for Partner Cancellation"
                          innerRef={register({
                            required:
                              "POST URL for Partner Cancellation is required",
                            pattern: {
                              value: /^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)+([/?].*)?$/i,
                              message:
                                "Invalid POST URL for Partner Cancellation",
                            },
                          })}
                          errors={errors}
                        />
                      </Col>
                    </Col>
                  </FormGroup>
                </Col>
              </div>

              <FormGroup
                as={Row}
                className="mb-3 align-items-center mt-3"
                controlId="formHorizontalEmail"
              >
                <FormLabel
                  className="d-sm-flex align-items-center mb-1"
                  style={{ fontSize: "13px" }}
                  column
                  sm={12}
                >
                  The following information will be pushed to partner's server:
                </FormLabel>

                <Col sm={12}>
                  <Row className="ml-3 p-0">
                    <FormGroup check className="">
                      <Input
                        type="radio"
                        id="postApiBodyType-Curl"
                        label="Curl"
                        name="postApiBodyType"
                        value="Curl"
                        defaultChecked={true}
                        innerRef={register()}
                      />
                      <FormLabel>Curl</FormLabel>
                    </FormGroup>
                    <FormGroup className="mx-2" check>
                      <Input
                        inline
                        type="radio"
                        id="postApiBodyType-JSON"
                        label="JSON"
                        name="postApiBodyType"
                        value="JSON"
                        defaultChecked={false}
                        innerRef={register()}
                      />
                      <FormLabel>JSON</FormLabel>
                    </FormGroup>
                    <FormGroup check className="">
                      <Input
                        type="radio"
                        id="postApiBodyType-Sikka"
                        label="Sikka"
                        name="postApiBodyType"
                        value="Sikka"
                        defaultChecked={false}
                        innerRef={register()}
                      />
                      <FormLabel>Sikka</FormLabel>
                    </FormGroup>
                  </Row>
                </Col>
              </FormGroup>
              <FormGroup className="mb-3 align-items-center">
                {/* <Col> */}
                <Col style={{ marginLeft: "19px" }}>
                  <Row className="d-flex">
                    {sampleInfo.map((info, index) => {
                      return (
                        <Col
                          key={index}
                          className="col-12 col-md-6 col-lg-6 col-xl-6"
                        >
                          <Input
                            type="checkbox"
                            id={info}
                            label={info}
                            name="postApiFields"
                            value={info}
                            innerRef={register({
                              required: "API Fields is required",
                              validate: () => {
                                return watch("postApiFields").length > 0;
                              },
                            })}
                            defaultChecked={marketPlaceListingValues?.postApiFields?.includes(
                              info
                            )}
                          />
                          <FormLabel>{info}</FormLabel>
                        </Col>
                      );
                    })}
                    <SikkaError
                      error={errors["postApiFields"]?.message}
                      className="mt-1"
                    />
                  </Row>
                </Col>
              </FormGroup>
            </>
          )}
          {automaticRegistrationHandshake[automaticRegistrationHandshakeIdx] ===
            "No" && (
            <>
              <div className="d-flex mt-4">
                <Col>
                  <FormGroup className="mb-3 align-items-center">
                    <Col className="p-0">
                      <FormLabel
                        className="d-flex align-items-center mb-0"
                        style={{ fontSize: "13px" }}
                      >
                        For Support:{" "}
                        <span style={{ color: "#e63757", marginLeft: "3px" }}>
                          *
                        </span>
                      </FormLabel>

                      <Col className="p-0" style={{ marginTop: "-13px" }}>
                        <SikkaInput
                          name="forSupport"
                          size="sm"
                          defaultValue={marketPlaceListingValues.forSupport}
                          onChange={(e) => {
                            setValue("forSupport", e.target.value, { shouldDirty: true });  
                          }}
                          id="forSupport"
                          placeholder="Email"
                          innerRef={register({
                            required: "For Support Email is required",
                            pattern: {
                              value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                              message: "Invalid Support Email",
                            },
                          })}
                          errors={errors}
                        />
                      </Col>
                    </Col>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup className="mb-3 align-items-center">
                    <Col className="p-0">
                      <FormLabel
                        className="d-flex align-items-center mb-0"
                        style={{ fontSize: "13px" }}
                      >
                        For Registration:{" "}
                        <span style={{ color: "#e63757", marginLeft: "3px" }}>
                          *
                        </span>
                      </FormLabel>

                      <Col className="p-0" style={{ marginTop: "-13px" }}>
                        <SikkaInput
                          name="forRegistration"
                          size="sm"
                          defaultValue={
                            marketPlaceListingValues.forRegistration
                          }
                          onChange={(e) => {
                            setValue("forRegistration", e.target.value, { shouldDirty: true });
                          }}
                          id="forRegistration"
                          placeholder="Email"
                          innerRef={register({
                            required: "For Registration Email is required",
                            pattern: {
                              value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                              message: "Invalid Registration Email",
                            },
                          })}
                          errors={errors}
                        />
                      </Col>
                    </Col>
                  </FormGroup>
                </Col>
              </div>
            </>
          )}
        </CardBody>
        <Card.Footer
          className={classNames("px-md-6 bg-light d-flex justify-content-end", {
            "d-none": step === 3,
            " d-sm-flex": step < 3,
          })}
        >
          <IconButton
            variant="primary"
            disabled={!selectedApplication}
            icon={"chevron-left"}
            iconAlign="left"
            size="sm"
            transform="down-1 shrink-4"
            className={classNames("px-5 mr-3 fw-semi-bold", {
              "d-none": step === 1,
            })}
            onClick={() => {
              setStep(step - 1);
              location.reload();
            }}
          >
            Prev
          </IconButton>

          {step < 3 && (
            <IconButton
              variant="primary"
              disabled={!selectedApplication}
              className="ms-auto px-5"
              size="sm"
              icon={"chevron-right"}
              iconAlign="right"
              type="submit"
              transform="down-1 shrink-4"
            >
              Next
            </IconButton>
          )}
        </Card.Footer>
      </Card>
    </Form>
  );
};

export default MarketPlaceListing;
